import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import {HttpHeaders} from "@angular/common/http";

export class StationContactsByUserDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.STATIONCONTACTSBYUSER, apiHelper);
  }

  sendEmail(data, publicId?: string) {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/sendEmail';
    let headers: HttpHeaders;

    if (publicId) {
      headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
    } else {
      headers = this.apiHelper.getDefaultHeader();
    }
    return this.apiHelper.apiCall(url, 'POST', null, data, headers);
  }

  find(search: Object): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/find';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, search, headers);
  }

  createOrAppend(request: CreateOrAppendStationContactRequest) {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/createOrAppend';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, request, headers);
  }
}

export interface CreateOrAppendStationContactRequest {
  stations: string[];
  user: string;
  email: string;
}

export interface CreateOrAppendStationContactRequest {
  stations: string[];
  user: string;
  email: string;
}
